import axios from 'axios'
import { LEADS_ENDPOINT } from '../../endpoints'
import * as FileSaver from 'file-saver';
import { XML_TYPE, b64toBlob } from 'Utilities';
import { ErrorAction } from '../../../features/common/redux/toasts';

export async function uploadCargaMasivaLeads(file, isUploadedFile,downloadInvalidLeadsReport) {
    const formData = new FormData()
    formData.append('file', file)

    let url = `${LEADS_ENDPOINT}/massiveLeads?uploadFiles=${isUploadedFile}`
    if(downloadInvalidLeadsReport) url += `&downloadInvalidLeadsReport=${downloadInvalidLeadsReport}`
    
    const response = await axios.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 1_800_000, // 30 minutos
    })

    if (isUploadedFile || downloadInvalidLeadsReport) {
        const files = b64toBlob(response.data.excelReport, XML_TYPE);

        if (!files) ErrorAction({ title: 'Ocurrió un error al guardar el archivo' })
        FileSaver.saveAs(files, 'ResultadodeimportaciónLead.xlsx')
    }
    return response
}
